module.exports = __webpack_public_path__ + "static/media/vaxtrace.638468bd.png";